import { render, staticRenderFns } from "./saveConfigStatusBarButton.vue?vue&type=template&id=0daf0f9a&scoped=true&"
import script from "./saveConfigStatusBarButton.vue?vue&type=script&lang=js&"
export * from "./saveConfigStatusBarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daf0f9a",
  null
  
)

export default component.exports